var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.messages
    ? _c(
        "f7-list",
        {
          staticClass: "background-f7-list-transaction-list",
          class: _vm.itemListClass,
          attrs: { "media-list": "", id: "payments-item-received" },
        },
        [
          _c("li", [
            _c(
              "table",
              { staticClass: "table table-bordered table-hover result-table" },
              [
                _c(
                  "thead",
                  {
                    staticClass: "background-thead-transaction-list",
                    attrs: { contextmenu: "" },
                  },
                  [
                    _c("tr", [
                      _c(
                        "th",
                        { staticClass: "head-table", attrs: { scope: "col" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("common.rsn")) +
                              "\n                  "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        { staticClass: "head-table", attrs: { scope: "col" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("common.status.status_label")) +
                              "\n                  "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        { staticClass: "head-table", attrs: { scope: "col" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("common.amnt")) +
                              "\n                  "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        { staticClass: "head-table", attrs: { scope: "col" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("common.debtor_name")) +
                              "\n                  "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        { staticClass: "head-table", attrs: { scope: "col" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("common.exec_date")) +
                              "\n                  "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.messages, function (message) {
                    return _c(
                      "tr",
                      {
                        key: message.id,
                        class:
                          {
                            messageSelected:
                              message.id && message.id === _vm.actualMessageId,
                          } +
                          " " +
                          _vm.bakcgroundSeenStatus,
                        on: {
                          click: function ($event) {
                            return _vm.seeDetails(message, true)
                          },
                        },
                      },
                      [
                        _c("td", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.getMessageLabel(message)) +
                              "\n                    "
                          ),
                          _vm.notEmpty(message.attachmentId)
                            ? _c(
                                "span",
                                { staticClass: "paperclip" },
                                [
                                  _vm._v("\n                       "),
                                  _c("f7-icon", {
                                    attrs: { size: "17px", fa: "paperclip" },
                                  }),
                                ],
                                1
                              )
                            : _vm.notEmpty(message.AttachmentsNumber)
                            ? _c(
                                "span",
                                { staticClass: "paperclip" },
                                [
                                  _vm._v("\n                       "),
                                  _vm._l(
                                    message.AttachmentsNumber,
                                    function (id) {
                                      return _c("f7-icon", {
                                        key: id,
                                        attrs: { fa: "paperclip" },
                                      })
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "showLargeScreenOnly w-27-5 min-w-27-5 mw-27-5",
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.getStatusLabel(message)) +
                                  "\n                    "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.serviceId === _vm.services.PAYMENTS
                          ? _c("td", { staticClass: "showLargeScreenOnly" }, [
                              _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "m-0",
                                    class: _vm.getDirectionClass(message),
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.getDirectionSymbol(message)
                                        ) +
                                        " " +
                                        _vm._s(_vm.getAmount(message)) +
                                        " €\n                      "
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.serviceId === _vm.services.DIRECTPAYMENTS
                          ? _c("td", { staticClass: "showLargeScreenOnly" }, [
                              _c(
                                "div",
                                {
                                  class:
                                    "font-weight-" +
                                    _vm.getSeenStatusFontWeight(message.isRead),
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "m-0",
                                      class: [
                                        message.direction === "0"
                                          ? "positif_amount"
                                          : "negatif_amount",
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            message.direction === "0"
                                              ? "+"
                                              : "-"
                                          ) +
                                          " " +
                                          _vm._s(_vm.getAmount(message)) +
                                          " €\n                      "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.serviceId === _vm.services.DOCUMENTSERVICE
                          ? _c("td", { staticClass: "showLargeScreenOnly" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.getDocumentInfo(message)) +
                                  "\n                  "
                              ),
                            ])
                          : _c("td", { staticClass: "showLargeScreenOnly" }, [
                              message.TotalPayments
                                ? _c("div", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          message.TotalPayments + " paiements"
                                        ) +
                                        "\n                    "
                                    ),
                                  ])
                                : message.direction === "0"
                                ? _c("div", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t("common.from_label") +
                                            ": " +
                                            _vm.getSenderName(message)
                                        ) +
                                        "\n                    "
                                    ),
                                  ])
                                : _c("div", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.getRecipientName(message)) +
                                        "\n                    "
                                    ),
                                  ]),
                            ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "showLargeScreenOnly text-center" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.datePresentationLabel) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatDate")(_vm.getDate(message))
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "swipeout-actions-right showSmallScreenOnly",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "swipeout-delete",
                                    attrs: { href: "#" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.del_label")))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.canDelete()
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-media showLargeScreenOnly",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button-swipe-out",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteOnWeb(
                                              message.id,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("f7-icon", {
                                          staticClass:
                                            "button-delete close_margin",
                                          attrs: { f7: "close", size: "17px" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "item-title-row showSmallScreenOnly" },
                          [
                            _vm.serviceId === _vm.services.DOCUMENTSERVICE
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "item-subtitle showSmallScreenOnly white-space-normal",
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.getDocumentInfo(message)) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "item-title-row showSmallScreenOnly" },
                          [
                            _c("span", { staticClass: "statusLabel" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.getStatusLabel(message)) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "item-after" },
                              [
                                message.reminder === "1"
                                  ? _c("f7-icon", {
                                      staticClass: "orangeFont",
                                      attrs: { fa: "bell" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }